import _ from 'lodash';

export const escapeRegex = (value: string) => {
	return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

export const interlace = (
	first: Array<any>,
	second: Array<any>
): Array<any> => {
	return _(_.zip(first, second))
		.flatten()
		.compact()
		.value();
};

export const takeFirst = (
	limit: number,
	list: Array<any>,
	predicate: Function
): Array<any> => {
	const newList: Array<any> = [];
	_.forEach(list, value => {
		predicate(value) && newList.push(value);
		return newList.length < limit;
	});
	return newList;
};
